
import styled from 'styled-components'

// eslint-disable-next-line import/prefer-default-export
export const Time = styled.time`
  display: block;
  font-size: 1rem;
  margin-bottom: 20px;
`
